<template>
  <div>
    <v-skeleton-loader
      height="950"
      v-if="getTeamLoader"
      :loading="getTeamLoader"
      class="mb-3 mt-4"
      type="list-item-avatar-two-line,table@2"
      elevation="2"
    >
    </v-skeleton-loader>
    <v-sheet v-else elevation="2" color="#57bc90" style="min-height: 70vh">
      <v-col cols="12" md="12" sm="12">
        <div v-if="scoring.data">
          <v-data-table
            :headers="headers"
            :items="scoring.data"
            class="elevation-1"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <!-- Date -->
            <template v-slot:item.DateTime="{ item }">
              <p class="blue--text">{{ item.DateTime | IsoToIst }} EST</p>
            </template>
            <!-- Date -->

            <!-- points -->
            <template v-slot:item.FantasyPointsDraftKings="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2">
                {{ item.FantasyPointsFanDuel }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2">
                {{ item.FantasyPointsDraftKings }}
              </p>
            </template>
            <!-- points -->

            <!-- salary -->
            <template v-slot:item.DraftKingsSalary="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2 green--text">
                ${{ item.FanDuelSalary }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2 green--text">
                $ {{ item.DraftKingsSalary }}
              </p>
            </template>
            <!-- salary -->

            <!--$ per pts -->
            <template v-slot:item.FantasyPoints="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2">
                {{ (item.FanDuelSalary / item.FantasyPointsFanDuel) >> 0 }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2">
                {{
                  (item.DraftKingsSalary / item.FantasyPointsDraftKings) >> 0
                }}
              </p>
            </template>
            <!-- $ per pts -->
          </v-data-table>
        </div>
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Nbascoring",
  props: {
    scoring: {
      type: [Array, Object],
      default: () => [],
      // required: true,
    },
  },
  computed: {
    ...mapState("NbaModule", ["operator"]),
    ...mapGetters("NbaModule", ["getTeamLoader"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Date",
          value: "DateTime",
          sortable: false,
        },
        {
          text: "Opponent",
          value: "Opponent",
        },
        {
          text: "Fantasy Points",
          value: "FantasyPointsDraftKings",
          sortable: false,
        },

        { text: "Salary", value: "DraftKingsSalary" },
        // { text: 'Minutes', value: 'minutes' },
        { text: "$ Per Point", value: "FantasyPoints" },
      ],
    };
  },
};
</script>

<style scoped></style>
